import { useState, useEffect, useRef } from "react";
import PageHeader from "../PageHeader/PageHeader";

const ChangeableHeaderV2 = ({
	content,
	spanTitleYellow,
	titleBanner,
	appearSecondNavbar,
	withBanner,
	gEvolution,
	basic
}) => {
	const [moveAnimation, setMoveAnimation] = useState(undefined);
	const renderTimes = useRef(0);

	useEffect(() => {
		renderTimes.current++;

		if (appearSecondNavbar && renderTimes.current > 1) {
			setMoveAnimation("moveIn");
		} else if (!appearSecondNavbar && renderTimes.current > 2) {
			setMoveAnimation("moveOut");
		}
	}, [appearSecondNavbar]);


	return (
		<>
			<PageHeader changeableHeader moveAnimation={moveAnimation} />
		{	
			withBanner
			? <PageHeader withBanner={withBanner} />
			: basic
			? <PageHeader />
			:	<PageHeader
					gEvolution={gEvolution}
					withTitle
					titleBanner={titleBanner && content ? content.spanish.titleBanner : titleBanner}
					spanTitleYellow={spanTitleYellow &&  content ? content.spanish.titleYellowBanner : spanTitleYellow}
					// hideVisibility={appearSecondNavbar && renderTimes.current > 1}
				/>
			}
		</>
	);
};

export default ChangeableHeaderV2;
